module.exports = __webpack_public_path__ + "b9dfa6e74a9e2f0d58ea6d370e244a61.fbx";